import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// English translations
const enTranslations = {
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    and: 'and',
    welcome: 'Welcome',
    logout: 'Log out',
    profile: 'Profile',
    settings: 'Settings',
    help: 'Help',
    back: 'Back',
    continue: 'Continue',
    start: 'Start',
    finish: 'Finish',
    retry: 'Retry'
  },
  auth: {
    login: 'Sign in',
    register: 'Sign up',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    forgotPassword: 'Forgot your password?',
    resetPassword: 'Reset password',
    firstName: 'First name',
    lastName: 'Last name',
    birthDate: 'Date of birth',
    phone: 'Phone',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signUp: 'Sign up',
    signIn: 'Sign in',
    chooseRole: 'I am...',
    student: 'Student',
    parent: 'Parent/Guardian',
    childAge: "Your child's age",
    termsAgree: 'I accept the terms and conditions',
    loginSuccess: 'Signed in successfully!',
    registerSuccess: 'Registration successful!',
    logoutSuccess: 'Signed out successfully',
    invalidCredentials: 'Invalid email or password',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    passwordMismatch: 'Passwords do not match'
  },
  nav: {
    home: 'Home',
    dashboard: 'Dashboard',
    lessons: 'Units',
    exercises: 'Exercises',
    workshops: 'Workshops',
    progress: 'Progress',
    badges: 'Badges',
    chat: 'Messages',
    notifications: 'Notifications',
    children: 'My children',
    students: 'Students',
    reviews: 'Reviews',
    reports: 'Reports',
    admin: 'Administration'
  },
  sections: {
    vocabulary: 'Vocabulary & Lessons',
    grammar: 'Applied Grammar',
    pronunciation: 'Pronunciation & Assessment'
  },
  lessons: {
    title: 'Lessons',
    level: 'Level',
    duration: 'Duration',
    points: 'Points',
    start: 'Start lesson',
    continue: 'Continue',
    completed: 'Completed',
    locked: 'Locked',
    progress: 'Progress',
    materials: 'Materials',
    downloadPdf: 'Download PDF',
    downloadAudio: 'Download audio',
    flashcards: 'Flashcards',
    noLessons: 'No lessons available',
    completeToUnlock: 'Complete previous lessons to unlock'
  },
  exercises: {
    title: 'Exercises',
    question: 'Question',
    answer: 'Answer',
    correct: 'Correct!',
    incorrect: 'Incorrect',
    tryAgain: 'Try again',
    showAnswer: 'Show answer',
    nextQuestion: 'Next question',
    submit: 'Check',
    score: 'Score',
    timeLeft: 'Time left',
    completed: 'Exercise completed!',
    pointsEarned: 'Points earned',
    multipleChoice: 'Multiple choice',
    fillBlank: 'Fill in the blanks',
    ordering: 'Put in order',
    matching: 'Match',
    listening: 'Listen and answer',
    pronunciation: 'Pronunciation',
    freeWriting: 'Free writing',
    recordAudio: 'Record',
    stopRecording: 'Stop',
    playRecording: 'Play',
    writeAnswer: 'Write your answer...',
    aiReview: 'Being reviewed by AI...',
    teacherReview: 'Awaiting review',
    feedback: 'Feedback'
  },
  workshops: {
    title: 'Workshops',
    upcoming: 'Upcoming workshops',
    past: 'Past workshops',
    enrolled: 'Enrolled',
    enroll: 'Enroll',
    full: 'Full',
    joinNow: 'Join now',
    participants: 'participants',
    maxParticipants: 'Available spots',
    teacher: 'Teacher',
    date: 'Date',
    time: 'Time',
    duration: 'Duration',
    recording: 'Recording',
    watchRecording: 'Watch recording',
    noWorkshops: 'No workshops scheduled',
    reserve: 'Reserve',
    cancel: 'Cancel enrollment',
    live: 'Live',
    scheduled: 'Scheduled',
    completed: 'Completed'
  },
  gamification: {
    points: 'Points',
    level: 'Level',
    badges: 'Badges',
    streak: 'Streak',
    streakDays: 'day streak',
    leaderboard: 'Leaderboard',
    rank: 'Rank',
    weeklyPoints: 'Points this week',
    totalPoints: 'Total points',
    newBadge: 'New badge earned!',
    badgeEarned: 'Badge earned',
    keepStreak: 'Keep your streak going!',
    lostStreak: 'Streak lost',
    rarity: {
      common: 'Common',
      rare: 'Rare',
      epic: 'Epic',
      legendary: 'Legendary'
    }
  },
  subscription: {
    trial: 'Trial period',
    trialEnds: 'Trial ends',
    daysLeft: 'days left',
    upgrade: 'Upgrade to full version',
    active: 'Active subscription',
    expired: 'Subscription expired',
    renew: 'Renew',
    features: 'Included features',
    price: 'Price',
    payNow: 'Pay now',
    paymentSuccess: 'Payment successful!',
    paymentFailed: 'Payment failed'
  },
  parent: {
    myChildren: 'My children',
    addChild: 'Add a child',
    childProgress: 'Progress',
    attendance: 'Attendance',
    chatTeacher: 'Contact teacher',
    payments: 'Payments',
    paymentHistory: 'Payment history'
  },
  teacher: {
    myStudents: 'My students',
    pendingReviews: 'Pending reviews',
    myWorkshops: 'My workshops',
    createWorkshop: 'Create workshop',
    availability: 'Availability',
    reviews: 'Reviews',
    review: 'Review',
    addFeedback: 'Add feedback',
    score: 'Score'
  },
  certificate: {
    title: 'Certificate',
    download: 'Download',
    verify: 'Verify',
    verificationCode: 'Verification code',
    issuedTo: 'Issued to',
    issuedOn: 'Issued on',
    completion: 'Certificate of completion',
    a1Level: 'A1 Level - English'
  },
  errors: {
    generic: 'An error occurred',
    network: 'Connection error',
    notFound: 'Page not found',
    unauthorized: 'Unauthorized access',
    forbidden: 'Access forbidden',
    serverError: 'Server error'
  }
}

// Traducciones en español (subtítulos)
const esTranslations = {
  common: {
    loading: 'Cargando...',
    error: 'Ha ocurrido un error',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    next: 'Siguiente',
    previous: 'Anterior',
    submit: 'Enviar',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todo',
    yes: 'Sí',
    no: 'No',
    or: 'o',
    and: 'y',
    welcome: 'Bienvenido',
    logout: 'Cerrar sesión',
    profile: 'Perfil',
    settings: 'Configuración',
    help: 'Ayuda',
    back: 'Volver',
    continue: 'Continuar',
    start: 'Comenzar',
    finish: 'Terminar',
    retry: 'Reintentar'
  },
  auth: {
    login: 'Iniciar sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer contraseña',
    firstName: 'Nombre',
    lastName: 'Apellido',
    birthDate: 'Fecha de nacimiento',
    phone: 'Teléfono',
    noAccount: '¿No tienes una cuenta?',
    hasAccount: '¿Ya tienes una cuenta?',
    signUp: 'Registrarse',
    signIn: 'Iniciar sesión',
    chooseRole: 'Soy...',
    student: 'Estudiante',
    parent: 'Padre/Tutor',
    childAge: 'Edad de tu hijo',
    termsAgree: 'Acepto los términos y condiciones',
    loginSuccess: '¡Inicio de sesión exitoso!',
    registerSuccess: '¡Registro exitoso!',
    logoutSuccess: 'Sesión cerrada',
    invalidCredentials: 'Correo o contraseña incorrectos',
    emailRequired: 'El correo es requerido',
    passwordRequired: 'La contraseña es requerida',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordMismatch: 'Las contraseñas no coinciden'
  },
  nav: {
    home: 'Inicio',
    dashboard: 'Panel',
    lessons: 'Unidades',
    exercises: 'Ejercicios',
    workshops: 'Talleres',
    progress: 'Progreso',
    badges: 'Des insignes',
    chat: 'Mensajes',
    notifications: 'Notificaciones',
    children: 'Mis hijos',
    students: 'Estudiantes',
    reviews: 'Correcciones',
    reports: 'Reportes',
    admin: 'Administración'
  },
  sections: {
    vocabulary: 'Vocabulario y Lecciones',
    grammar: 'Gramática Aplicada',
    pronunciation: 'Pronunciación y Evaluación'
  },
  lessons: {
    title: 'Lecciones',
    level: 'Nivel',
    duration: 'Duración',
    points: 'Puntos',
    start: 'Comenzar lección',
    continue: 'Continuar',
    completed: 'Completado',
    locked: 'Bloqueado',
    progress: 'Progreso',
    materials: 'Material',
    downloadPdf: 'Descargar PDF',
    downloadAudio: 'Descargar audio',
    flashcards: 'Tarjetas de memoria',
    noLessons: 'No hay lecciones disponibles',
    completeToUnlock: 'Completa las lecciones anteriores para desbloquear'
  },
  exercises: {
    title: 'Ejercicios',
    question: 'Pregunta',
    answer: 'Respuesta',
    correct: '¡Correcto!',
    incorrect: 'Incorrecto',
    tryAgain: 'Intenta de nuevo',
    showAnswer: 'Ver respuesta',
    nextQuestion: 'Siguiente pregunta',
    submit: 'Verificar',
    score: 'Puntuación',
    timeLeft: 'Tiempo restante',
    completed: '¡Ejercicio completado!',
    pointsEarned: 'Puntos ganados',
    multipleChoice: 'Opción múltiple',
    fillBlank: 'Completa los espacios',
    ordering: 'Ordena',
    matching: 'Empareja',
    listening: 'Escucha y responde',
    pronunciation: 'Pronunciación',
    freeWriting: 'Escritura libre',
    recordAudio: 'Grabar',
    stopRecording: 'Detener',
    playRecording: 'Reproducir',
    writeAnswer: 'Escribe tu respuesta...',
    aiReview: 'Corrigiendo con IA...',
    teacherReview: 'Esperando corrección del profesor',
    feedback: 'Comentarios'
  },
  workshops: {
    title: 'Talleres',
    upcoming: 'Próximos talleres',
    past: 'Talleres pasados',
    enrolled: 'Inscrito',
    enroll: 'Inscribirse',
    full: 'Lleno',
    joinNow: 'Unirse ahora',
    participants: 'participantes',
    maxParticipants: 'Lugares disponibles',
    teacher: 'Profesor',
    date: 'Fecha',
    time: 'Hora',
    duration: 'Duración',
    recording: 'Grabación',
    watchRecording: 'Ver grabación',
    noWorkshops: 'No hay talleres programados',
    reserve: 'Reservar',
    cancel: 'Cancelar inscripción',
    live: 'En vivo',
    scheduled: 'Programado',
    completed: 'Completado'
  },
  gamification: {
    points: 'Puntos',
    level: 'Nivel',
    badges: 'Des insignes',
    streak: 'Racha',
    streakDays: 'días consecutivos',
    leaderboard: 'Clasificación',
    rank: 'Posición',
    weeklyPoints: 'Puntos esta semana',
    totalPoints: 'Puntos totales',
    newBadge: '¡Nueva insignia obtenida!',
    badgeEarned: 'Insignia ganada',
    keepStreak: '¡Mantén tu racha!',
    lostStreak: 'Racha perdida',
    rarity: {
      common: 'Común',
      rare: 'Raro',
      epic: 'Épico',
      legendary: 'Legendario'
    }
  },
  subscription: {
    trial: 'Período de prueba',
    trialEnds: 'Fin de la prueba',
    daysLeft: 'días restantes',
    upgrade: 'Obtener versión completa',
    active: 'Suscripción activa',
    expired: 'Suscripción expirada',
    renew: 'Renovar',
    features: 'Características incluidas',
    price: 'Precio',
    payNow: 'Pagar ahora',
    paymentSuccess: '¡Pago exitoso!',
    paymentFailed: 'Error en el pago'
  },
  parent: {
    myChildren: 'Mis hijos',
    addChild: 'Agregar hijo',
    childProgress: 'Progreso',
    attendance: 'Asistencia',
    chatTeacher: 'Contactar profesor',
    payments: 'Pagos',
    paymentHistory: 'Historial de pagos'
  },
  teacher: {
    myStudents: 'Mis estudiantes',
    pendingReviews: 'Correcciones pendientes',
    myWorkshops: 'Mis talleres',
    createWorkshop: 'Crear taller',
    availability: 'Disponibilidad',
    reviews: 'Correcciones',
    review: 'Corregir',
    addFeedback: 'Agregar comentario',
    score: 'Calificación'
  },
  certificate: {
    title: 'Certificado',
    download: 'Descargar',
    verify: 'Verificar',
    verificationCode: 'Código de verificación',
    issuedTo: 'Otorgado a',
    issuedOn: 'Otorgado el',
    completion: 'Certificado de finalización',
    a1Level: 'Nivel A1 - Inglés'
  },
  errors: {
    generic: 'Ha ocurrido un error',
    network: 'Error de conexión',
    notFound: 'Página no encontrada',
    unauthorized: 'Acceso no autorizado',
    forbidden: 'Acceso prohibido',
    serverError: 'Error del servidor'
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations }
    },
    lng: 'en', // Default language: English
    fallbackLng: 'en', // Fallback: English
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
